/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React,{useEffect, useState} from 'react'
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GlobalContext from '../../components/Context/GloablContext';
import ErrorMessage from '../../components/ErrorMessage';
import Loader from '../../components/Loader';
import { userService } from '../../services/user.services';
import BannerImage from './BannerImage'
import { passwordCriteria } from './passwordCriteria'
import { branchLiveKey } from '../../config';

export default function PasswordReset() {
    const {setToastmessage} =useContext(GlobalContext)
    const navigate = useNavigate();
    const auth = useSelector(state => state.auth);
    const [loadingPage, setLoadingPage] = useState(true)
    const [password, setpassword] = useState('');
    const [Newpassword, setNewpassword] = useState('');
    const [submitSelected, setsubmitSelected] = useState(false);
    const [type, settype] = useState('password');
    const [btn, setbtn] = useState('password');
    const [loading, setloading] = useState(false)
    const [OverallError, setOverallError] = useState('')
    const [invalidAutoPassword, setinvalidAutoPassword] = useState('')
    const [sessionData, setSessionData] = useState({})

    // Mobile Authentication cONDITIONALLY

    const isResetFromWebsite = window.location.search.includes('src=mobile');

    // const endpoint = isResetFromWebsite
    //     ? 'users/reset-password-website' // Endpoint for website-initiated resets
    //     : 'users/forgot-password-verify-link'; // Endpoint for other resets

    // if (isResetFromWebsite) {
    //     window.location.href = '/website-home-page'; // Redirect to website's home page
    // } else {
    //     navigate('/'); // Redirect to the mobile app's home page
    // }


    /**
     * The above function handles the form submission for resetting a password in a React application.
     * @returns The function `handleSubmit` does not have a return statement, so it does not explicitly
     * return anything.
     */
    const handleSubmit=async(e)=>{
        e.preventDefault()
        setsubmitSelected(true);
        setOverallError('')
        setloading(true)
        if(password===''||Newpassword===''){
            setloading(false)
            return;
        }
        // if(!passwordRegex.test(password)){
        //     setloading(false)
        //     return;
        // }

        const payload={
            "session_token": sessionData.custom_object.token,
            "url": sessionData["+url"],
            "confirm_password":password,
            "new_password": Newpassword, 
        }
        const endpoint=`users/forgot-password-verify-link`

        const ResetResponse = await userService.forgotPassword(endpoint,payload);
        if(ResetResponse?.data?.message){
            setToastmessage(ResetResponse.data.message);
            localStorage.clear();
            if (isResetFromWebsite) {
                navigate('/mobile-reset-password')
            } else {
                navigate('/'); // Redirect to the mobile app's home page
            }
            // navigate('/')
        }else{
            if(ResetResponse.message.response.data.message==='Invalid auto-generated password. Please check and try again'){
                setinvalidAutoPassword(ResetResponse.message.response.data.message)
            }else{
                setOverallError(ResetResponse.message.response.data.message)

            }
            setloading(false)
        }

    }


    /**
     * The function `handleBranchLink` retrieves data from a branch URL and updates the session data if
     * successful, otherwise it navigates to a 404 page.
     */
    const handleBranchLink = async() => {
        try {
            const urlParams = new URLSearchParams(window.location.search);
            const branchUrl = urlParams.get('branch_url');
            const res = await userService.BranchGet(branchUrl, branchLiveKey)
            if(res.error) {
                navigate('/404')    
            } else {
                setLoadingPage(false)
                setSessionData(res.data.data)
            }
        } catch (error) {
            navigate('/404')
            console.log('error', error)
        } 
    };

    /* The above code is using the useEffect hook in React to call the handleBranchLink function when
    the component is mounted. The empty array [] as the second argument ensures that the effect is
    only run once, when the component is initially rendered. */
    useEffect(() => {
        handleBranchLink();
    }, []);
    return (
        <>
            {!loadingPage && <div className='flex md:flex-row flex-col md:bg-[#fff] bg-[#EEF7FE] md:h-auto min-h-screen max-h-screen overflow-auto md:px-0 md:py-0 px-6 py-10'>
                <BannerImage />
                <div className="md:w-1/2 w-full relative md:mt-0 mt-[18px]">
                    <div className="w-full flex flex-col justify-center md:min-h-screen md:max-h-max md:shadow-s1 pb-2">
                        <div className="ml-4 absolute top-[10%] left-0 md:block hidden">
                            <a href="/" className="flex items-center backBtnLogin">
                                <span><img src="/images/back-btnBlue.svg" alt="btn" loading="lazy"/></span>
                                <span className="pl-3 text-lg font-medium text-[#106EB4]">Back</span>
                            </a>
                        </div>
                        <img src="/images/SkuTeq-Logo.svg" alt="product-logo" className="mx-auto" loading="lazy"/>
                        {/* <!-- login section --> */}  
                        <div className="login-section mx-auto">
                            <p className="text-center md:pt-[23px] pt-[18px] text-xl font-semibold text-[#031624] resetPassword-errShow">Reset Password</p>
                            <div className="mx-auto">
                                <div className="lg:w-[350px] md:w-[80%] w-[95%] mx-auto">
                                    <p className="md:pt-5 pt-[18px] text-base text-[#031624] text-center">Please enter a new password to reset your account password</p>
                                    <form onSubmit={(e)=>handleSubmit(e)} className="mt-[30px]">
                                        <div className="flex flex-col">
                                            <label for="newPassword" className="text-f1 font-medium text-[#344054] pb-1.5">New Password</label>
                                            <div className="relative">
                                                <input 
                                                    type={type}
                                                    onChange={(e)=>setpassword(e.target.value)} 
                                                    value={password} 
                                                    id="newPassword" 
                                                    style={{border:`1px solid ${submitSelected &&password===''?'#FDA29B':'#D0D5DD'}`}}
                                                    onFocus={()=>{
                                                        setsubmitSelected(false);
                                                        setOverallError('')
                                                        setinvalidAutoPassword('')

                                                    }}
                                                    className="err-border w-full border border-[#D0D5DD] rounded py-2.5 pl-3.5 pr-[39px] outline-0 sm:placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal sm:text-f2 text-sm font-normal text-[#101828]" autocomplete="off" placeholder="Enter Password" />
                                                <button type="button" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-2">
                                                    {type==='text'?<img src="/images/eye-open.svg" loading="lazy" alt="password-show" className="password-show" onClick={()=>settype('password')} />
                                                        :<img src="/images/eye-closed.svg" loading="lazy" alt="password-hide" className="password-show" onClick={()=>settype('text')}/>}
                                                </button>
                                            </div>
                                            <p className="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err hidden">New password is mandatory</p>
                                            {submitSelected &&password==='' && <ErrorMessage 
                                                error 
                                                message={"New password is mandatory"}
                                                classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"
                                            />}
                                        

                                        
                                        </div>
                                        <p className="text-f1 font-normal text-[#667085] pt-4">Please make sure your password includes the following:</p>
                                        <ul className="mt-1 pl-2">
                                            {Object.keys(passwordCriteria).map((criteria)=>(
                                                <li className="flex items-center mb-1" key={criteria}>
                                                    <span>
                                                        <img src={!passwordCriteria[criteria]["regex"].test(password)?`/images/login-bulletPOint.svg`:`/images/otp-tick.svg`} alt="img" loading="lazy" className="password-weak" id={criteria} />
                                                    </span>
                                                    <span className="text-f1 font-normal text-[#667085] pl-[11px]"> {criteria}</span>
                                                </li>
                                            ))}
                                        </ul>
                                        <div className="flex flex-col mt-[26px]">
                                            <label for="ConformNewPassword" className="text-f1 font-medium text-[#344054] pb-1.5">Confirm New Password</label>
                                            <div className="relative">
                                                <input 
                                                    type={btn} 
                                                    onChange={(e)=>setNewpassword(e.target.value)} 
                                                    style={{border:`1px solid ${(submitSelected &&Newpassword==='' || Newpassword?.length>0&& Newpassword!==password)?'#FDA29B':'#D0D5DD'}`}}
                                                    value={Newpassword}
                                                    onFocus={()=>{
                                                        setsubmitSelected(false);
                                                        setOverallError('')
                                                        setinvalidAutoPassword('')
                                                    }}
                                                    id="ConformNewPassword" 
                                                    className="err-border w-full border border-[#D0D5DD] rounded py-2.5 px-3.5 outline-0 sm:placeholder:text-f2 placeholder:text-[#818E98] placeholder:font-normal sm:text-f2 font-normal text-[#101828]" 
                                                    autocomplete="off"
                                                    placeholder="Enter Password" />
                                                <button type="button" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-2">
                                                    {btn==='text'?<img loading="lazy" src="/images/eye-open.svg" alt="password-show" className="password-show" onClick={()=>setbtn('password')} />
                                                        :<img loading="lazy" src="/images/eye-closed.svg" alt="password-hide" className="password-show" onClick={()=>setbtn('text')}/>}
                                                </button>
                                            </div>
                                        </div>
                                        <p className="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError hidden">Confirm password is mandatory</p>
                                        {submitSelected &&Newpassword==='' && <ErrorMessage 
                                            error 
                                            message={"Confirm password is mandatory"}
                                            classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"/>}
                                        {Newpassword?.length>0&&password!==Newpassword && <ErrorMessage 
                                            error 
                                            message={"New password and confirm password do not match."}
                                            classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"
                                        />}
                                        {OverallError!=='' && <ErrorMessage 
                                            error 
                                            message={OverallError}
                                            classKey="pt-1.5 text-f1 font-normal text-[#F04438] resetPage-err resetError"
                                        />}
                                        <button 
                                            type="submit"
                                            id="resetpwd-form"
                                            disabled={(password!==Newpassword ||loading)}
                                            className="w-full bg-[#106EB4] py-3 rounded mt-5 text-f2 font-normal text-[#ffffff] ltr-spcng-8 hover:bg-[#1C8ADC] hover:duration-75">
                                            {!loading?'Reset Password':<span>{<Loader />}</span>}
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>}
        </>
    )
}
